import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'semantic-ui-react';
import loadable from '@loadable/component';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { flattenToAppURL } from '@plone/volto/helpers';
import { flattenHTMLToAppURL } from '@plone/volto/helpers/Url/Url';
import Slider from 'react-slick';
import { ConditionalEmbed} from 'volto-gdpr-privacy';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styleBando.css';

const MapComponent = loadable(() => import('./MapComponent'), {
  ssr: false,
  fallback: <div>Caricamento mappa...</div>,
});

// Configurazione del carosello
const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  return isNaN(day) ? '' : `${day}-${month}-${year}, ${hour}:${minute}`;
};

// Estrae i link da un campo HTML
const extractLinksFromHTML = (html) => {
  if (!html) return [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const links = Array.from(doc.querySelectorAll('a[href]'));
  return links.map(link => ({
    url: link.getAttribute('href'),
    text: link.textContent || link.getAttribute('href')
  })).filter(link => link.url && !link.url.startsWith('#'));
};

const BandoView = ({ content }) => {
  // const lat = parseFloat(content.latitudine);
  // const lng = parseFloat(content.longitudine);
  // const hasValidCoordinates = !isNaN(lat) && !isNaN(lng);
  // const coordinates = hasValidCoordinates ? [lat, lng] : [51.505, -0.09];

  const [activeSection, setActiveSection] = useState(null);
  const [accordionOpen, setAccordionOpen] = useState(true);
  const progressRef = useRef(null);

  const [attachments, setAttachments] = useState([]);
  const [esiti, setEsiti] = useState([]);
  const [relatedContents, setRelatedContents] = useState([]);
  const [comunications, setComunications] = useState([]);
  const [loading, setLoading] = useState({
    attachments: false,
    esiti: false,
    relatedContents: false,
    comunications: false
  });
  const location = useLocation();

  //console.log(attachments);
  //console.log('collegamenti');
  //console.log(relatedContents);

  useEffect(() => {
    const fetchData = async () => {
      setLoading({
        attachments: true,
        esiti: true,
        relatedContents: true,
        comunications: true,
      });

      const isLocalhost =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';
      const apiPrefix = isLocalhost ? '' : '/api';

      // Sostituisci la funzione fetchFolderContents con questa versione corretta:

      const fetchFolderContents = async (folderName, portalTypes) => {
        const folderPath = `${location.pathname.replace(/\/$/, '')}/${folderName}/`;
        try {
          const types = Array.isArray(portalTypes) ? portalTypes : [portalTypes];
          const response = await axios.get(`${apiPrefix}/++api++${folderPath}@search`, {
            params: {
              portal_type: types,
              sort_on: 'getObjPositionInParent',
              b_size: 100,
              path: {
                query: folderPath,
                depth: 1,
              },
            },
          });

          // Filtro migliorato per escludere solo le cartelle e gli elementi non desiderati
          const filteredItems = (response.data?.items || []).filter(item => {
            // Escludi sempre le cartelle
            if (item['@type'] === 'Folder') {
              return false;
            }

            // Ottieni il path dell'elemento senza il dominio
            let itemPath = new URL(item['@id']).pathname;

            // Normalizza i path rimuovendo /api/ se presente
            const normalizedItemPath = itemPath.replace('/api/', '/');
            const normalizedFolderPath = folderPath.replace('/api/', '/');

            // Controlla che l'elemento sia direttamente figlio della cartella
            const isDirectChild = normalizedItemPath.startsWith(normalizedFolderPath) &&
              normalizedItemPath !== normalizedFolderPath.replace(/\/$/, '') &&
              !normalizedItemPath.replace(normalizedFolderPath, '').includes('/');

            //console.log(`Elemento: ${item.title}, Path originale: ${itemPath}, Path normalizzato: ${normalizedItemPath}, Cartella normalizzata: ${normalizedFolderPath}, È figlio diretto: ${isDirectChild}`);

            return isDirectChild;
          });

          // Versione più robusta per gestire i link - sostituisci la sezione dei link:

          if (types.includes('Link')) {
            const itemsWithLinkData = await Promise.all(
              filteredItems.map(async (item) => {
                if (item['@type'] === 'Link') {
                  try {
                    const path = new URL(item['@id']).pathname;

                    // Prova diverse varianti del path per l'API
                    const pathVariants = [
                      path.replace(/^\/api/, ''),  // Rimuovi /api/ se presente
                      path,                        // Path originale
                      path.replace(/^\//, ''),     // Rimuovi / iniziale
                    ];

                    let linkData = null;
                    let successPath = null;

                    for (const variant of pathVariants) {
                      try {
                        const testUrl = `${apiPrefix}/++api++${variant}`;
                        //console.log(`Tentativo chiamata API per ${item.title}: ${testUrl}`);

                        const response = await axios.get(testUrl);
                        linkData = response.data;
                        successPath = variant;
                        break;
                      } catch (err) {
                        console.log(`Fallito con path ${variant}:`, err.response?.status || err.message);
                        continue;
                      }
                    }

                    if (linkData) {
                      //console.log(`Link ${item.title} caricato con successo usando path: ${successPath}`);
                      //console.log(`RemoteUrl trovato: ${linkData.remoteUrl}`);

                      return {
                        ...item,
                        remoteUrl: linkData.remoteUrl || '',
                      };
                    } else {
                      console.error(`Impossibile caricare i dati per il link ${item.title}`);
                      return item;
                    }
                  } catch (error) {
                    console.error(`Errore generale nel caricamento del link ${item['@id']}:`, error);
                    return item;
                  }
                }
                return item;
              })
            );
            return itemsWithLinkData;
          }

          // Aggiungi "/@@download/file" ai contenuti di tipo File
          const itemsWithDownloadLinks = filteredItems.map(item => {
            if (item['@type'] === 'File') {
              return {
                ...item,
                '@id': item['@id'] + '/@@download/file',
              };
            }
            return item;
          });

          return itemsWithDownloadLinks;          
        } catch (error) {
          console.error(`Errore nel caricamento ${folderName}:`, error);
          return [];
        }
      };

      const fetchImmediateChildren = async (portalTypes) => {
        const folderPath = location.pathname.replace(/\/$/, '');
        try {
          const types = Array.isArray(portalTypes) ? portalTypes : [portalTypes];
          const response = await axios.get(`${apiPrefix}/++api++${folderPath}/@search`, {
            params: {
              portal_type: types,
              sort_on: 'getObjPositionInParent',
              b_size: 100,
              path: {
                query: folderPath,
                depth: 1,
              },
            },
          });

          // Cambiato da const a let
          let items = response.data?.items || [];

          if (types.includes('Link')) {
            const itemsWithLinkData = await Promise.all(
              items.map(async (item) => {
                if (item['@type'] === 'Link') {
                  try {
                    const path = new URL(item['@id']).pathname;
                    const linkData = await axios.get(`${apiPrefix}/++api++${path}`);
                    return {
                      ...item,
                      remoteUrl: linkData.data.remoteUrl || '',
                    };
                  } catch (error) {
                    console.error(`Errore nel caricamento del link ${item['@id']}:`, error);
                    return item;
                  }
                }
                return item;
              })
            );
            items = itemsWithLinkData;
          }

          // Aggiungi "/@@download/file" per i File
          const itemsWithDownloadLinks = items.map(item => {
            if (item['@type'] === 'File') {
              return {
                ...item,
                '@id': item['@id'] + '/@@download/file',
              };
            }
            return item;
          });

          return itemsWithDownloadLinks;
        } catch (error) {
          console.error('Errore nel caricamento dei contenuti figli:', error);
          return [];
        }
      };




    // Rileva se siamo dentro una sottopagina di "comunicazioni"
    const isPaginaDettaglio =
      content['@type'] === 'Document' &&
      location.pathname.includes('/comunicazioni/');

    const comunicazioni = isPaginaDettaglio
      ? await fetchImmediateChildren(['File', 'Link', 'Document'])
      : await fetchFolderContents('comunicazioni', ['File', 'Link', 'Document']);

    const [allegati, esiti, collegamenti] = await Promise.all([
      fetchFolderContents('allegati', 'File'),
      fetchFolderContents('esiti', 'File'),
      fetchFolderContents('collegamenti', 'Link'),
    ]);

    setAttachments(allegati);
    setEsiti(esiti);
    setRelatedContents(collegamenti);
    setComunications(comunicazioni);
    //console.log('Comunicazioni caricate:', comunicazioni);


    setLoading({
      attachments: false,
      esiti: false,
      relatedContents: false,
      comunications: false,
    });
  };

  fetchData();
}, [location.pathname, content.contenuti_correlati]);


  const hasAttachments = attachments.length > 0;
  const hasEsiti = esiti.length > 0;
  const hasRelatedContents = relatedContents.length > 0;
  const hasComunications = comunications.length > 0;  

  // Data corrente
  const adesso = new Date();

  // Determiniamo lo stato del bando
  let statoBando = "";
  let iconaBando = "";
  let coloreBando = "";
  let statoBandoClasse = "";

  const effectiveDate = content?.effective;
  // Verifica se le date sono valide prima di creare gli oggetti Date
  const isValidDateString = (dateString) => {
    return dateString && dateString !== null && !isNaN(new Date(dateString).getTime());
  };

  // Formatta la data di pubblicazione
  const dataPubblicazione = isValidDateString(content?.effective) ? new Date(content.effective) : null;
  const dayDataPubblicazione = dataPubblicazione ? dataPubblicazione.getDate().toString().padStart(2, '0') : null;
  const monthDataPubblicazione = dataPubblicazione ? dataPubblicazione.toLocaleString('it-IT', { month: 'long' }) : null;
  const yearDataPubblicazione = dataPubblicazione ? dataPubblicazione.getFullYear() : null;

  // Formatta la data di apertura
  const dataApertura = isValidDateString(content?.data_apertura) ? new Date(content.data_apertura) : null;
  const dayDataApertura = dataApertura ? dataApertura.getDate().toString().padStart(2, '0') : null;
  const monthDataApertura = dataApertura ? dataApertura.toLocaleString('it-IT', { month: 'long' }) : null;
  const yearDataApertura = dataApertura ? dataApertura.getFullYear() : null;
  const hourDataApertura = dataApertura ? dataApertura.getHours().toString().padStart(2, '0') : null;
  const minutesDataApertura = dataApertura ? dataApertura.getMinutes().toString().padStart(2, '0') : null;

  // Formatta la data termine richiesta
  const dataTerminerichiesta = isValidDateString(content?.termine_chiarimenti) ? new Date(content.termine_chiarimenti) : null;
  const dayDataTerminerichiesta = dataTerminerichiesta ? dataTerminerichiesta.getDate().toString().padStart(2, '0') : null;
  const monthDataTerminerichiesta = dataTerminerichiesta ? dataTerminerichiesta.toLocaleString('it-IT', { month: 'long' }) : null;
  const yearDataTerminerichiesta = dataTerminerichiesta ? dataTerminerichiesta.getFullYear() : null;
  const hourDataTerminerichiesta = dataTerminerichiesta ? dataTerminerichiesta.getHours().toString().padStart(2, '0') : null;
  const minutesDataTerminerichiesta = dataTerminerichiesta ? dataTerminerichiesta.getMinutes().toString().padStart(2, '0') : null;

  // Formatta la data di scadenza
  const dataScadenza = isValidDateString(content?.data_scadenza) ? new Date(content.data_scadenza) : null;
  const dayDataScadenza = dataScadenza ? dataScadenza.getDate().toString().padStart(2, '0') : null;
  const monthDataScadenza = dataScadenza ? dataScadenza.toLocaleString('it-IT', { month: 'long' }) : null;
  const yearDataScadenza = dataScadenza ? dataScadenza.getFullYear() : null;
  const hourDataScadenza = dataScadenza ? dataScadenza.getHours().toString().padStart(2, '0') : null;
  const minutesDataScadenza = dataScadenza ? dataScadenza.getMinutes().toString().padStart(2, '0') : null;

  // Formatta la data di chiusura
  const dataChiusura = isValidDateString(content?.data_chiusura_procedimento) ? new Date(content.data_chiusura_procedimento) : null;
  const dayDataChiusura = dataChiusura ? dataChiusura.getDate().toString().padStart(2, '0') : null;
  const monthDataChiusura = dataChiusura ? dataChiusura.toLocaleString('it-IT', { month: 'long' }) : null;
  const yearDataChiusura = dataChiusura ? dataChiusura.getFullYear() : null;

  // Aggiornare anche la logica per determinare lo stato del bando:
  if (dataChiusura && dataChiusura < adesso) {
    statoBando = "Chiuso";
    iconaBando = "rectangle-xmark";
    coloreBando = "#5b6f82";
    statoBandoClasse = "closed";
  } else if (dataScadenza && dataScadenza < adesso) {
    statoBando = "In corso";
    iconaBando = "circle-info";
    coloreBando = "#221bb3";
    statoBandoClasse = "inProgress";
  } else if (dataScadenza && dataScadenza >= adesso) {
    statoBando = "Attivo";
    iconaBando = "circle-check";
    coloreBando = "#008053";
    statoBandoClasse = "open";
  } else if (dataApertura && dataApertura > adesso) {
    statoBando = "Programmato";
    iconaBando = "calendar";
    coloreBando = "#585499";
    statoBandoClasse = "scheduled";
  }
  
  // if (!isValidDate) {
  //   return null; // Non renderizza nulla se la data non è valida
  // }

  const availableMenuItems = [
    { id: 'descrizione', label: 'Descrizione', show: !!content.testo?.data },
    { id: 'tipologia_bando', label: 'Tipologia del bando', show: !!content.tipologia_bando?.title },
    { id: 'destinatari_bando', label: 'Destinatari del bando', show: !!(content.destinatari?.[0]?.title) },
    { id: 'ente_erogatore', label: 'Ente erogatore', show: !!(content.ente?.[0]?.title) },
    { id: 'tempi_e_scadenza', label: 'Tempi e scadenze', show: !!(dataPubblicazione || dataApertura || dataTerminerichiesta || dataScadenza || dataChiusura) },
    { id: 'ulteriori_informazioni', label: 'Ulteriori informazioni', show: !!content.ulteriori_informazioni?.data },
    { id: 'note_aggiornamento', label: 'Note aggiornamento', show: !!content?.note_aggiornamento },        
    { id: 'capacità-ricettiva', label: 'Capacità ricettiva', show: !!content.capacitaricettiva?.data },
    { id: 'età', label: 'Età', show: !!content.eta?.data },
    { id: 'caratteristiche', label: 'Caratteristiche', show: !!content.caratteristiche?.data },
    { id: 'modalità-di-accesso', label: 'Modalità di accesso', show: !!content.modalitaaccesso?.data },
    { id: 'indirizzo', label: 'Indirizzo', show: !!content.indirizzo },
    { id: 'orari', label: 'Orari', show: !!content.orari?.data },
    { id: 'contatti', label: 'Contatti', show: !!content.contatti?.data },
    { id: 'allegati', label: 'Allegati', show: hasAttachments },    
    { id: 'contenuti-correlati', label: 'Collegamenti', show: hasRelatedContents },
    { id: 'comunicazioni', label: 'Comunicazioni', show: hasComunications },    
    { id: 'esiti', label: 'Esiti', show: hasEsiti },
    
  ].filter((item) => item.show);

  useEffect(() => {
    const sectionIds = availableMenuItems.map((item) => item.id);
    const sectionElements = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;

      if (progressRef.current) {
        progressRef.current.style.width = `${scrolled}%`;
        progressRef.current.setAttribute('aria-valuenow', scrolled.toFixed(2));
      }

      let current = null;
      for (let el of sectionElements) {
        const rect = el.getBoundingClientRect();
        if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
          current = el.id;
          break;
        }
      }
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [availableMenuItems]);

  //console.log(content);

  return (
    <Container>
      <h1>{content.title}</h1>

      {content.description && (
        <section id="sottotitolo" style={{ marginBottom: '30px' }}>
          <p className="documentDescription">{content.description}</p>
        </section>
      )}

      {statoBando && (
        <div className={`genericcard card card-teaser shadow p-3 mt-3 rounded bando_state ${statoBandoClasse}`}>
          <div className="card-body">
            <div className="card-text"><i className={`af-icon fa-regular fa-${iconaBando}`} style={{color: coloreBando}}></i>{statoBando}</div>
          </div>
        </div>
      )}

      {content.image?.download && (
        <div className="header-image-wrapper">
          <img
            className="header-image responsive"
            src={flattenToAppURL(content.image.download)}
            alt={content.title}
          />
        </div>
      )}

      <div className="bando-layout-wrapper">

        {/* Indice */}
        {availableMenuItems.length > 0 && (
          <div className="page-index-wrapper">

            <div className="sticky-wrapper navbar-wrapper page-side-menu">
              <nav className="navbar it-navscroll-wrapper navbar-expand-lg">
                <div className="menu-wrapper">
                  <div className="link-list-wrapper menu-link-list">
                    <div className="accordion-wrapper">
                      <div className="accordion">
                        <div className="accordion-header">
                          <button
                            onClick={() => setAccordionOpen(!accordionOpen)}
                            className="accordion-button"
                            aria-expanded={accordionOpen}
                            aria-controls="side-menu-body"
                            type="button"
                          >
                            Indice della pagina
                          </button>
                        </div>

                        <div className="mb-3">
                          <div className="progress">
                            <div className="progress-bar-label">
                              <span className="visually-hidden"></span>
                            </div>
                            <div
                              className="progress-bar"
                              role="progressbar"
                              ref={progressRef}
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{ width: '0%' }}
                            ></div>
                          </div>
                        </div>

                        {accordionOpen && (
                          <div className="collapse show" id="side-menu-body">
                            <div className="accordion-body">
                              <ul className="link-list" data-element="page-index">
                                {availableMenuItems.map((item, index) => (
                                  <li className="nav-item" key={index}>
                                    <a
                                      className={`nav-link ${
                                        activeSection === item.id ? 'active' : ''
                                      }`}
                                      href={`#${item.id}`}
                                      id={`item-${item.id}`}
                                    >
                                      <span>{item.label}</span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        )}

        {/* Contenuto */}
        <div className="dettaglio-bando">

          {content.testo?.data && (
            <section id="descrizione" style={{ marginBottom: '30px' }}>
              <h2>Descrizione</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.testo.data),
                }}
              />
            </section>
          )}

          {content.tipologia_bando?.title && (
            <section id="tipologia_bando" style={{ marginBottom: '30px' }}>
              <h4>Tipologia del bando</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.tipologia_bando.title),
                }}
              />
            </section>
          )}

          {content?.destinatari && content.destinatari.length > 0 && (
            <section id="destinatari_bando" style={{ marginBottom: '30px' }}>
              <h4>Destinatari del bando</h4>
              <div>
                {content.destinatari.map((destinatario, index) => (
                  <span key={destinatario.token || index}>
                    {destinatario.title}
                    {index < content.destinatari.length - 1 && ', '}
                  </span>
                ))}
              </div>
            </section>
          )}

          {content?.destinatari && content.destinatari.length > 0 && (
            <section id="ente_erogatore" style={{ marginBottom: '30px' }}>
              <h4>Ente erogatore</h4>
              <div>
                {content.ente.map((ente, index) => (
                  <span key={ente.token || index}>
                    {ente.title}
                    {index < content.ente.length - 1 && ', '}
                  </span>
                ))}
              </div>
            </section>
          )}         

          {(dataPubblicazione || dataApertura || dataTerminerichiesta || dataScadenza || dataChiusura) && (
            <section id="tempi_e_scadenza" style={{ marginBottom: '30px' }}>
              <h4>Tempi e scadenza</h4>
              <div class="point-list-wrapper my-4 mb-5">                

                {dataPubblicazione && (
                  <div class="point-list">
                    <div class="point-list-aside point-list-warning" aria-label='{dataPubblicazione}'>
                      <span class="point-date font-monospace" aria-hidden="true">{dayDataPubblicazione}</span>
                      <span class="point-month" aria-hidden="true">{monthDataPubblicazione}</span>
                      <span class="point-month" aria-hidden="true">{yearDataPubblicazione}</span>
                    </div>
                    <div class="point-list-content">
                      <div class="card card-teaser rounded shadow border-left-card card">
                        <div class="card-body card-body">
                          <p class="card-title">Data di pubblicazione</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}      

                {dataApertura && (
                  <div class="point-list">
                    <div class="point-list-aside point-list-warning" aria-label='{dataApertura}'>
                      <span class="point-date font-monospace" aria-hidden="true">{dayDataApertura}</span>
                      <span class="point-month" aria-hidden="true">{monthDataApertura}</span>
                      <span class="point-month" aria-hidden="true">{yearDataApertura}</span>
                    </div>
                    <div class="point-list-content">
                      <div class="card card-teaser rounded shadow border-left-card card">
                        <div class="card-body card-body">
                          <p class="card-title">{hourDataApertura}:{minutesDataApertura} - Apertura del bando</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}    

                {dataTerminerichiesta && (
                  <div class="point-list">
                    <div class="point-list-aside point-list-warning" aria-label='{dataTerminerichiesta}'>
                      <span class="point-date font-monospace" aria-hidden="true">{dayDataTerminerichiesta}</span>
                      <span class="point-month" aria-hidden="true">{monthDataTerminerichiesta}</span>
                      <span class="point-month" aria-hidden="true">{yearDataTerminerichiesta}</span>
                    </div>
                    <div class="point-list-content">
                      <div class="card card-teaser rounded shadow border-left-card card">
                        <div class="card-body card-body">
                          <p class="card-title">{hourDataTerminerichiesta}:{minutesDataTerminerichiesta} - Termine per le richieste di chiarimenti</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}      

                {dataScadenza && (
                  <div class="point-list">
                    <div class="point-list-aside point-list-warning" aria-label='{dataScadenza}'>
                      <span class="point-date font-monospace" aria-hidden="true">{dayDataScadenza}</span>
                      <span class="point-month" aria-hidden="true">{monthDataScadenza}</span>
                      <span class="point-month" aria-hidden="true">{yearDataScadenza}</span>
                    </div>
                    <div class="point-list-content">
                      <div class="card card-teaser rounded shadow border-left-card card">
                        <div class="card-body card-body">
                          <p class="card-title">{hourDataScadenza}:{minutesDataScadenza} - Scadenza dei termini per partecipare al bando</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                {dataChiusura && !isNaN(dataChiusura.getTime()) && (
                  <div class="point-list">
                    <div class="point-list-aside point-list-warning" aria-label='{dataChiusura}'>
                      <span class="point-date font-monospace" aria-hidden="true">{dayDataChiusura}</span>
                      <span class="point-month" aria-hidden="true">{monthDataChiusura}</span>
                      <span class="point-month" aria-hidden="true">{yearDataChiusura}</span>
                    </div>
                    <div class="point-list-content">
                      <div class="card card-teaser rounded shadow border-left-card card">
                        <div class="card-body card-body">
                          <p class="card-title">Chiusura del procedimento</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
              </div>
            </section>
          )}

          {content.ulteriori_informazioni?.data &&(
            <section id="ulteriori_informazioni" style={{ marginBottom: '30px' }}>
              <h4>Ulteriori informazioni</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.ulteriori_informazioni.data),
                }}
              />
            </section>
          )}

          {content?.note_aggiornamento &&(
            <section id="ulteriori_informazioni" style={{ marginBottom: '30px' }}>
              <h4>Note aggiornamento</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.note_aggiornamento),
                }}
              />
            </section>
          )}
                   
          {content.capacitaricettiva?.data && (
            <section id="capacità-ricettiva" style={{ marginBottom: '30px' }}>
              <h4>Capacità ricettiva</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.capacitaricettiva.data),
                }}
              />
            </section>
          )}

          {content.eta?.data && (
            <section id="età" style={{ marginBottom: '30px' }}>
              <h4>Età</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.eta.data),
                }}
              />
            </section>
          )}

          {content.caratteristiche?.data && (
            <section id="caratteristiche" style={{ marginBottom: '30px' }}>
              <h4>Caratteristiche</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.caratteristiche.data),
                }}
              />
            </section>
          )}

          {content.modalitaaccesso?.data && (
            <section id="modalità-di-accesso" style={{ marginBottom: '30px' }}>
              <h4>Modalità di accesso</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.modalitaaccesso.data),
                }}
              />
            </section>
          )}         

          {content.orari?.data && (
            <section id="orari" style={{ marginBottom: '30px' }}>
              <h4>Orari</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.orari.data),
                }}
              />
            </section>
          )}

          {content.contatti?.data && (
            <section id="contatti" style={{ marginBottom: '30px' }}>
              <h4>Contatti</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: flattenHTMLToAppURL(content.contatti.data),
                }}
              />
            </section>
          )}

          {/* Sezione Allegati */}
          {loading.attachments ? (
            <p>Caricamento allegati...</p>
          ) : hasAttachments && (
            <section id="allegati" className="sottocartelle" style={{ marginBottom: '30px' }}>
              <h5>Allegati</h5>
              <div className="simple-card-container">
                <div className="simple-card-listing"
                  style={{
                    gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`
                  }}
                >
                  {attachments.map((item) => (
                    <div className="simple-card" key={item['@id']}>
                      <div className="card-content card-allegato">
                        <a
                          href={flattenToAppURL(item['@id'])}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="currentColor"
                            className="bi bi-link-45deg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M11 22c-1.6.1-2.9-1.2-3-2.8V6c0-2.2 1.8-4 4-4s4 1.8 4 4v10h-1V6c0-1.7-1.3-3-3-3S9 4.3 9 6v13c0 1.1.9 2 2 2s2-.9 2-2V8c0-.6-.4-1-1-1s-1 .4-1 1v8h-1V8c0-1.1.9-2 2-2s2 .9 2 2v11c.1 1.6-1.2 2.9-2.8 3H11z"></path>
                          </svg> */}
                          <i className="af-icon fa-regular fa-paperclip" tyle={{color: '#191380'}}></i>
                          {item.title || item.id}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          
          {/* Sezione Contenuti Correlati */}
          {loading.relatedContents ? (
            <p>Caricamento contenuti correlati...</p>
          ) : hasRelatedContents && (
            <section id="contenuti-correlati" className="sottocartelle" style={{ marginBottom: '30px' }}>
              <h5>Collegamenti</h5>
              <div className="simple-card-container">
                <div className="simple-card-listing"
                  style={{
                    gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`
                  }}
                >
                  
                  {relatedContents.map((item) => (
                    <div className="simple-card" key={item['@id']}>
                      <div className="card-content card-allegato">
                      
                      <a
                          href={flattenToAppURL(item['remoteUrl'])}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >                          
                          <i className="af-icon fa-regular fa-link" tyle={{color: '#191380'}}></i>
                          {item.title || item.id}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}
          
          {/* Sezione Comunicazioni */}
          {loading.comunications ? (
            <p>Caricamento comunicazioni...</p>
          ) : hasComunications && (
            <section id="comunicazioni" className="sottocartelle" style={{ marginBottom: '30px' }}>
              <h5>Comunicazioni</h5>
              <div className="simple-card-container">
                <div
                  className="simple-card-listing"
                  style={{
                    gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`,
                  }}
                >
                  {comunications.map((item) => {
                    let iconClass = 'fa-file-lines'; // default per Document
                    if (item['@type'] === 'File') iconClass = 'fa-paperclip';
                    else if (item['@type'] === 'Link') iconClass = 'fa-link';

                    const href =
                      item['@type'] === 'Link' && item.remoteUrl
                        ? flattenToAppURL(item.remoteUrl)
                        : item['@type'] === 'File'
                          ? flattenToAppURL(item['@id']) + '/@@download/file'
                          : flattenToAppURL(item['@id']);

                    return (
                      <div className="simple-card" key={item['@id']}>
                        <div className="card-content card-allegato">
                          <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                          >
                            <i className={`af-icon fa-regular ${iconClass}`} style={{ color: '#191380' }}></i>
                            {item.title || item.id}
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}

          {/* Sezione Esiti */}
          {loading.esiti ? (
            <p>Caricamento allegati...</p>
          ) : hasEsiti && (
            <section id="esiti" className="sottocartelle" style={{ marginBottom: '30px' }}>
              <h5>Esiti</h5>
              <div className="simple-card-container">
                <div className="simple-card-listing"
                  style={{
                    gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`
                  }}
                >
                  {esiti.map((item) => (
                    <div className="simple-card" key={item['@id']}>
                      <div className="card-content card-allegato">
                        <a
                          href={flattenToAppURL(item['@id'])}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="currentColor"
                            className="bi bi-link-45deg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M11 22c-1.6.1-2.9-1.2-3-2.8V6c0-2.2 1.8-4 4-4s4 1.8 4 4v10h-1V6c0-1.7-1.3-3-3-3S9 4.3 9 6v13c0 1.1.9 2 2 2s2-.9 2-2V8c0-.6-.4-1-1-1s-1 .4-1 1v8h-1V8c0-1.1.9-2 2-2s2 .9 2 2v11c.1 1.6-1.2 2.9-2.8 3H11z"></path>
                          </svg> */}
                          <i className="af-icon fa-regular fa-envelope-open-text" tyle={{color: '#191380'}}></i>
                          {item.title || item.id}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}  

          <div className="lastUpdate" style={{ marginTop: '40px' }}>
            <b>Ultimo aggiornamento:</b> {formatDate(content.modified)}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BandoView;